import * as React from 'react';
export const RSSvg = React.forwardRef(function RSSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2a2 2 0 0 0-2 2v2h16V4a2 2 0 0 0-2-2H2Z',
      fill: '#B84241',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 6v4h16V6H0Z',
      fill: '#1B4172',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 10v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2H0Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 6h4v3a2 2 0 1 1-4 0V6Z',
      fill: '#B84241',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1 10v1.995A1 1 0 0 0 1.994 13h12.012c.55 0 .994-.447.994-1.005V10h1v1.995A1.997 1.997 0 0 1 14.006 14H1.994A2 2 0 0 1 0 11.995V10h1Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 6H4l-.686-1.029c-.167-.25-.074-.586.21-.686C3.906 4.149 4.453 4 5 4c.547 0 1.093.15 1.477.285.283.1.376.436.209.686L6 6Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.5 6 5 7l1.5-1L7 9l-1.429-.714L6 10H4l.429-1.714L3 9l.5-3Z',
      fill: '#fff',
    }),
  );
});
RSSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var RS = {
  category: 'flag',
  colorable: false,
  name: 'RS',
  svg: RSSvg,
};
